/**
 * TokenDataTabs — Tab container for Trade History and Holder List.
 *
 * Each tab renders its own component that owns its data fetching (ARCH-16).
 *
 * Story 4.4 — Task 1
 */

import { Tabs } from "../ui/Tabs";
import { HolderList } from "./HolderList";
import { TradeHistory } from "./TradeHistory";

type TokenDataTabsProps = {
	tokenId: string;
};

export function TokenDataTabs({ tokenId }: TokenDataTabsProps) {
	return (
		<div className="rounded-xl border border-pastel-border bg-white p-5">
			<Tabs
				tabs={[
					{
						id: "trades",
						label: "Trades",
						content: <TradeHistory tokenId={tokenId} />,
					},
					{
						id: "holders",
						label: "Holders",
						content: <HolderList tokenId={tokenId} />,
					},
				]}
			/>
		</div>
	);
}
